import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    current: { },
    currentList: [],
    testStandards: [],
    testStandard: {}
  },
  mutations: {
    setCurrent (state, current) {
      state.current = current
    },
    setCurrentList (state, list) {
      state.currentList = list
    },
    setTestStandards (state, standards) {
      state.testStandards = standards
    },
    setTestStandard (state, standard) {
      state.testStandard = standard
    }
  },
  actions: {
    async storeTestRecordList ({rootState, commit}) {
      commit('setCurrentList', await api.getTestRecords(rootState.project.current._id))
    },
    async storeTestRecord ({commit, rootState}, _id) {
      commit('setCurrent', await api.getTestRecord(_id))
    },
    async add ({rootState, state, dispatch, commit}) {
      const newTestRecord = {...state.current}
      await api.addTestRecord({
        ...newTestRecord,
        project: rootState.project.current._id
      })

      await dispatch('storeTestRecordList')
    },
    async patch ({ state, dispatch, commit }) {
      const newTestRecord = {...state.current}

      await api.updateTestRecord(newTestRecord)

      await dispatch('storeTestRecordList')
    },
    async download ({rootState, state}) {
      let i = 1
      const result = await api.downloadTestRecord(rootState.project.current._id, state.currentList.map(item => {
        item.no = i
        i++
        return item
      }))
      require('downloadjs')(result, `材料設備檢驗管制表.docx`)
    },
    async delete ({state, dispatch}, id) {
      await api.deleteTestRecord(id)
      dispatch('storeTestRecordList')
    },
    async storeTestStandards ({rootState, commit}) {
      commit('setTestStandards', await api.getTestStandards(rootState.project.current._id))
    },
    async storeTestStandard ({commit}, testStandardId) {
      const result = await api.getTestStandard(testStandardId)
      commit('setTestStandard', result)
      return result
    },
    async addTestStandard ({state, rootState, dispatch}) {
      await api.addTestStandard(rootState.project.current._id, state.testStandard)
      dispatch('storeTestStandards')
    },
    async updateTestStandard ({state, dispatch}) {
      await api.updateTestStandard(state.testStandard)
      dispatch('storeTestStandards')
    },
    async deleteTestStandard ({state, dispatch}, testStandardId) {
      await api.deleteTestStandard(testStandardId)
      dispatch('storeTestStandards')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/testRecord.js